import {
    Modal,
    ModalBody,
    ModalContent,
    ModalDialog,
    ModalHeader,
    ModalFooter
} from 'arag-ui-lib';


const ModalWrapper = (props) => {
    const {
        isOpen,
        onClose,
        buttonTestId,
        modalTestId,
        size,
        children,
        footer,
        title,
    } = props;
    return (
        <Modal fadeIn={isOpen} darkenedBackground noScroll={true} modalTestId={modalTestId}>
            <ModalDialog size={size}>
                <ModalContent>
                    <ModalHeader onClose={onClose} closeModalButtonTestId={buttonTestId} title={title}/>
                    <ModalBody>
                        {children}
                    </ModalBody>
                    {
                        footer 
                        ?
                            <ModalFooter>
                                {footer}
                            </ModalFooter>
                        :
                            null
                    }
                </ModalContent>
            </ModalDialog>
        </Modal>
    );
};

export default ModalWrapper;